/*
 Copyright 2013-2017 the original author or authors from the JHipster project.

 This file is part of the JHipster project, see https://jhipster.github.io/
 for more information.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */
import { Component, Input } from '@angular/core';
/**
 * A wrapper directive on top of the translate pipe as the inbuilt translate directive from ng2-translate is too verbose and buggy
 */
/* tslint:disable */
var JhiTranslateComponent = (function () {
    function JhiTranslateComponent() {
    }
    return JhiTranslateComponent;
}());
export { JhiTranslateComponent };
JhiTranslateComponent.decorators = [
    { type: Component, args: [{
                selector: '[jhiTranslate]',
                template: '<span [innerHTML]="jhiTranslate | translate:translateValues"></span>'
            },] },
];
/** @nocollapse */
JhiTranslateComponent.ctorParameters = function () { return []; };
JhiTranslateComponent.propDecorators = {
    'jhiTranslate': [{ type: Input },],
    'translateValues': [{ type: Input },],
};



//////////////////
// WEBPACK FOOTER
// ./~/ng-jhipster/src/language/jhi-translate.directive.js
// module id = 1027
// module chunks = 3